/* eslint-disable class-methods-use-this */

import _ from 'lodash';
import WorkspaceFolderTree from '@patsnap-biz/workspace-folder-tree';
import {
    SECTION_TYPE_WORKSPACE,
} from '../constants';

const workspaceFolderStemStart = '|';

export default {

    data() {
        return {
            workspaceFolderTreeService: {},
        };
    },

    computed: {
        workspaceSuggestInfo() {
            /* return this.suggestion.filter((item) => item.section === SECTION_TYPE_WORKSPACE); */
            return _.find(this.suggestion, { section: SECTION_TYPE_WORKSPACE });
        },
        isWorkspaceSuggest() {
            return this.workspaceSuggestInfo && !_.isEmpty(this.workspaceSuggestInfo);
        },

        showWorkspaceSuggest() {
            const keyword = _.get(this.workspaceSuggestInfo, 'keyword', '');
            return this.isWorkspaceSuggest && !_.startsWith(keyword, workspaceFolderStemStart) && !_.endsWith(keyword, workspaceFolderStemStart);
        },
    },

    watch: {
        isWorkspaceSuggest: {
            handler(val) {
                if (val) {
                    const self = this;
                    class Service extends WorkspaceFolderTree.WorkspaceFolderTreeService {
                        constructor() {
                            super();
                            this.multipleFolder = false;
                        }

                        getWorkspaces() {
                            if (!self.showWorkspaceSuggest) return Promise.resolve({});
                            const params = _.get(self.workspaceSuggestInfo, 'params', {});
                            return self.specialSuggestRequest[SECTION_TYPE_WORKSPACE].getWorkspaces(params)
                                .then((res) => ({
                                    self: res.self || [],
                                    public: res.public || [],
                                }));
                        }

                        getFolders(spaceId, keyword) {
                            return self.specialSuggestRequest[SECTION_TYPE_WORKSPACE].getFolders({
                                space_id: spaceId,
                                folder_search_name: keyword,
                                just_check_read_patent_permit: true,
                            });
                        }

                        folderChangeCallback() {
                            const selectedFolder = this.selectedFolderListWithParentName[0];
                            if (!selectedFolder) return;

                            const folderName = [_.get(selectedFolder, 'folder_name')];
                            const spaceName = [_.get(selectedFolder, 'space_name')];
                            const folderParentNameList = _.get(selectedFolder, 'parent_name_list', []);

                            const folderPath = _.concat(spaceName, folderParentNameList, folderName).filter((item) => item).join('\\');

                            const option = {
                                section: SECTION_TYPE_WORKSPACE,
                                data: {
                                    value: folderPath,
                                },
                            };

                            self.$emit('select-option', option);
                        }
                    }

                    this.workspaceFolderTreeService = new Service();
                }
            },
            immediate: true,
        },
        'workspaceSuggestInfo.keyword': {
            handler(val) {
                this.workspaceFolderTreeService.setLoadWorkspacesKeyword(val);
            },
        },
    },

    methods: {
        preventDefaultEvent(e) {
            e.preventDefault();
            e.stopPropagation();
        },
    },
};
